/**
 * RG-04 Phase B — catalog ownership (platform | organization).
 *
 * Ownership invariant:
 * - Every catalog record belongs to exactly one ownership class.
 * - Platform: catalog_scope = platform AND organization_id IS NULL
 * - Organization: catalog_scope = organization AND organization_id NOT NULL
 * - Ownership class is immutable; clone rather than convert.
 */

export const CATALOG_SCOPE = Object.freeze({
  PLATFORM: "platform",
  ORGANIZATION: "organization",
});

export const CATALOG_OWNERSHIP_TABLES = Object.freeze([
  "feature_types",
  "assembly_templates",
  "work_type_templates",
]);

export function isCatalogOwnershipTable(tableName) {
  return CATALOG_OWNERSHIP_TABLES.includes(tableName);
}

/**
 * Visibility for catalog reads:
 * - with actor org: platform rows OR that organization's rows
 * - without actor org: platform rows only (never other tenants)
 */
export function applyCatalogVisibilityScope(query, organizationId) {
  if (!query) {
    return query;
  }

  if (!organizationId) {
    return query.eq("catalog_scope", CATALOG_SCOPE.PLATFORM);
  }

  return query.or(
    `catalog_scope.eq.${CATALOG_SCOPE.PLATFORM},organization_id.eq.${organizationId}`,
  );
}

/** Payload stamp for organization-owned catalog inserts. */
export function stampOrganizationCatalogScope(record, organizationId) {
  if (!record) {
    return record;
  }

  if (!organizationId) {
    return {
      ...record,
      catalog_scope: record.catalog_scope || CATALOG_SCOPE.PLATFORM,
      organization_id: null,
    };
  }

  return {
    ...record,
    catalog_scope: CATALOG_SCOPE.ORGANIZATION,
    organization_id: record.organization_id || organizationId,
  };
}

/** Payload stamp for platform catalog inserts (MVP defaults). */
export function stampPlatformCatalogScope(record) {
  if (!record) {
    return record;
  }

  return {
    ...record,
    catalog_scope: CATALOG_SCOPE.PLATFORM,
    organization_id: null,
  };
}
